/** Canonical customer destinations for legacy/provider links, preserving website deep links. */
export function customerDestination(pathname: string): string {
  if (pathname === "/portal" || pathname.startsWith("/portal/") || pathname === "/security" || pathname === "/wiki" || pathname.startsWith("/wiki/")) return pathname;
  if (pathname === "/sites" || pathname.startsWith("/sites/")) return `/portal${pathname}`;
  const aliases: Record<string, string> = {
    "/": "/portal", "/domains": "/portal/dns", "/dns": "/portal/dns",
    "/infrastructure/cloudflare": "/portal/cloudflare", "/infrastructure/mail": "/portal/mail",
    "/infrastructure/databases": "/portal/databases", "/infrastructure/cache": "/portal/performance",
    "/infrastructure/backup": "/portal/backups", "/audit": "/portal/activity",
    "/settings/notifications": "/portal/notifications", "/accounts": "/portal/team",
    "/storage/usage": "/portal/storage",
  };
  if (aliases[pathname]) return aliases[pathname];
  if (pathname.startsWith("/security/")) return "/portal/security";
  if (pathname.startsWith("/accounts/")) return "/portal/team";
  return "/portal";
}
